<template>
  <Permission type="Demo.Write" v-if="!isDemoModeEnabled">
    <Demo v-if="!hasLiveCallInProgress" v-bind="$attrs" />
    <template #no_auth>
      <LiveCallPlaceholder />
    </template>
  </Permission>
  <LiveCallPlaceholder v-else-if="!hasLiveCallInProgress" />
  <LiveCallHub v-if="hasLiveCallInProgress" v-bind="$attrs" />
</template>

<script setup lang="ts">
import Demo from "@/components/rules/Demo.vue";
import LiveCallHub from "@/components/contact/realtime/LiveCallHub.vue";
import LiveCallPlaceholder from "@/components/contact/realtime/LiveCallPlaceholder.vue";

import { useLiveCallStore } from "@/store/contact/live-call.ts";
import Permission from "@/components/auth/Permission.vue";
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useAuthStore } from "@/store/auth.ts";

const liveCallStore = useLiveCallStore();
const { isDemoModeEnabled } = storeToRefs(useAuthStore());

definePage({
  name: "calls/live",
});

defineOptions({
  inheritAttrs: false,
});

const hasLiveCallInProgress = computed<boolean>(() => {
  return !!liveCallStore.activeCall || liveCallStore.hasActiveCallEnded;
});
</script>
